import React, { useEffect, useState } from 'react'
import Icons from '../../../assets/icons'
import GenericCustomButton from '../../GenericCustomButton';
import { useDispatch, useSelector } from 'react-redux';
import { dispatchHandler } from '../../../helper/apiHelperFunctions';
import GenericInput from '../../input/GenericInputComponent';
import LanguageTranslator from '../../../locals/LanguageTranslator';
import ParentModal from '../../ParentModal';
import PrintDocument from '../../../printDocument/PrintDocument';
import { getPermissionKey } from '../../../helper/permissions';
import {motion, AnimatePresence} from "framer-motion";
import DocumentsQtyForPrint from '../../../printDocument/DocumentQtyForPrint';
import TextWithTooltip from '../../TextWithTooltip';

const DocumentsDropdown = (props) => {

    const dispatch = useDispatch();

    const { checkItems = [], downloadDocumentsConfigurationObject = {}, hidePreview = false, } = props;
    const downloadDocumentsData = useSelector(state => state?.generalStore?.downloadDocumentsData);
    const [expandedTable, setExpandedTable] = useState({});

    const [searchContent, setSearchContent] = useState("");

    const [selectedModal, setSelectedModal] = useState("");
    const [selectedData, setSelectedData] = useState(null);

    const downloadFunction = (config) => {
        console.log("config check",config)
        if (downloadDocumentsData?.isLoading) return;

        let { item, type, skipQtyModal = false, formData = [], qtyEnabled = false} = config

        let idKey = item?.["documentId"] || "shipmentId";
        let idDocumentNumber = item?.["documentNo"] || "shipmentAdviceCode";

        if(!skipQtyModal){
            if(["ITEM_BARCODE_SINGLE", "ITEM_QR_CODE_SINGLE"]?.includes(item?.key)){
                setSelectedModal("documentsQtyForPrint")
                setSelectedData({
                    type : type,
                    item, item
                })
                return;
            }
        }

        // Handle the case: Do we need to print the download documents or just download the file.
        if(!item?.["printDocument"] &&  window.location.hash?.includes("/mdm/manage/set")){
            setSelectedModal("printDocument");
            setSelectedData({
                ...config,
                checkItems : checkItems,
                barcodeKey : props.downloadDocuments?.barcodeKey
            });
        }else{
            if (idKey && idDocumentNumber) {
                let payload = {
                    "data": checkItems?.map((val, index) => {
                        if(qtyEnabled ? Number(formData?.[index]?.qty || "") > 0 : true){
                            let obj = {
                                "documentId": val?.[idKey] || "",
                                "documentNo": val?.[idDocumentNumber] || "",
                                ...(qtyEnabled ? { "qty" : Number(formData?.[index]?.qty || "")} : {})
                            }
                            item?.params?.split(',')?.map(key => {
                                obj[key] = val?.[key] || "";
                            })
                            return obj;
                        }
                    })?.filter(val => Boolean(val)) || [],
    
                    "filters": item?.["filters"] ? item?.["filters"] : {},
                    "type": item?.key || "",
                    "disposition": type
                }
                // Download the document data
                dispatchHandler(dispatch, "downloadDocumentsRequest", payload, getPermissionKey("common", "commonFunctionality", "downloadpdf"))
            }
        }
    }

    const handleChange = (type, item, config = {}) => {

        let { level } = config;

        switch (type) {
            case "mouseOver": {
                if (item?.["explore"]?.data) {
                    let updatedData = { ...expandedTable };
                    updatedData[level] = item;
                    let updatedSearchContent = { ...searchContent };

                    let maxValue = Math.max(...Object.keys(expandedTable || {}))

                    // Remove all the data above this level from the expanded table
                    for (let i = level + 1; i <= maxValue; i++) {
                        delete updatedData[i];
                        delete updatedSearchContent?.[i]
                    }
                    setExpandedTable(updatedData);
                    setSearchContent(updatedSearchContent)
                }
                break;
            }
            case "mouseLeave": {
                let updatedData = { ...expandedTable };
                let maxValue = Math.max(...Object.keys(expandedTable || {}))

                let updatedSearchContent = { ...searchContent };

                // Remove all the data above this level from the expanded table
                for (let i = level; i <= maxValue; i++) {
                    delete updatedData[i];
                    delete updatedSearchContent?.[i + 1]
                }
                setExpandedTable(updatedData);
                setSearchContent(updatedSearchContent)
                break
            }
            case "downloadBarcode": {
                let { expandMoreJson = {}, expandData = {} } = item
                downloadFunction({
                    item: expandData,
                    type: "FALSE",
                    exploreDataDownload: true,
                    expandMoreJson,
                    expandData,
                })
                props.OpenDocumentsDropdown();
            }
            default :
        }

    }

    const modifyItemForPrinterBarcode = ({ ...item }) => {
        if (item?.["exploreData"]) {
            item["explore"] = {};
            item["explore"]["data"] = [];

            item["explore"]["data"] = JSON.parse(item?.exploreData?.value || "[]")?.map(val => {

                let filters = {};
                ["barCodeId"]?.map(key => { filters[key] = val?.[key] })

                return {
                    ...item,
                    "explore": null,
                    "exploreData": null,
                    "value": val?.["displayName"] || "",
                    "filters": filters,
                    "type": "printerBarcode"
                }
            })
            delete item?.["exploreData"];
        }

        return item;
    }

    // Function :  TO check if the preview button should be hidden or not
    const isPreviewButtonHidden = (key) => {
        if(hidePreview) return true;

        if(Object.keys(expandedTable || {})?.length > 0 && ["ITEM_PRINTER_BARCODE", "SET_PRINTER_BARCODE"]?.includes(expandedTable?.[Object.keys(expandedTable)?.length-1]?.key) || ["PRODUCT_QR_CODE"]?.includes(key)){
            return true;
        }
        return false;
    }

    const slideVariants = {
    hidden: (direction) => ({
        x: direction === "left" ? "100%" : "-100%",
        opacity: 0,
    }),
    visible: {
        x: 0,
        opacity: 1,
        transition: {
        type: "tween",
        duration: 0.3,
        },
    },
    exit: (direction) => ({
        x: direction === "left" ? "-100%" : "100%",
        opacity: 0,
        transition: {
        type: "tween",
        duration: 0.3,
        },
    }),
    };

    const renderDownloadDocumentList = (listData = [], level = 0) => {
        // console.log("List data", listData, listData?.filter(item => item?.value?.includes(searchContent?.[level] || "")))

        const isExpanded = expandedTable?.hasOwnProperty(level);
        const direction = isExpanded ? "left" : "right";

        return (
            <div className='w-full h-full overflow-hidden'>
                <AnimatePresence initial={false} custom={direction}>
                <motion.div
                    key={`level-${level}-${isExpanded ? "expanded" : "collapsed"}`}
                    custom={direction}
                    variants={slideVariants}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                    className="absolute h-full w-full bg-white"
                >
                {!expandedTable?.hasOwnProperty(level) ?
                    <div className='h-full flex flex-col'>
                        <div className='sticky top-[0] bg-white z-[3]'>
                            <div className='px-3 pt-3 border-b'>
                                <LanguageTranslator tag='h2' className='text-custom-16 font-bold'>Documents Download</LanguageTranslator>

                                {listData?.length > 5 &&
                                    <GenericInput
                                        className='placeholder:font-normal'
                                        inputKey={"searchIcon"}
                                        value={searchContent?.[level]}
                                        placeholder={"Search Document"}
                                        onChange={(e) => setSearchContent({ ...searchContent, [level]: e?.target?.value || "" })}
                                        iconLeft={<span className='mr-1'><Icons.GlobalSearchIcon /></span>}
                                        dependentFieldsObject={["searchIcon"]}
                                    />
                                }
                            </div>
                                {level > 0 &&
                                <div className='flex items-center gap-1 pl-3 pr-6 pt-[6px] pb-1.5 whitespace-nowrap border-b'>
                                    <div className='p-1.5 bg-gray-100 rounded mr-2 cursor-pointer hover:brightness-90'
                                        onClick={() => { handleChange("mouseLeave", expandedTable?.[level - 1], { level: level - 1 }) }}
                                    ><Icons.BackArrowIcon2 /></div>

                                    {
                                        Object.keys(expandedTable || {})?.sort()?.map(key =>
                                            <>
                                                {key != 0 && <div className='text-xs font-semibold'>/</div>}
                                                <GenericCustomButton
                                                    className='!ml-0 text-xs font-semibold px-[1px] w-fit text-fontBlack hover:text-primary'
                                                    label={`${expandedTable?.[key]?.value}`}
                                                    onClick={() => handleChange("mouseLeave", expandedTable?.[key], { level: key })}
                                                />
                                            </>
                                        )
                                    }
                                </div>
                            }
                        </div>

                        <div className='py-1 h-full overflow-y-auto'>
                            {/* {level > 0 &&
                                <div className='flex items-center gap-1 pl-3 pr-6 pt-[4px] pb-2 whitespace-nowrap'>
                                    <div className='p-1.5 bg-gray-100 rounded mr-2 cursor-pointer hover:brightness-90'
                                        onClick={() => { handleChange("mouseLeave", expandedTable?.[level - 1], { level: level - 1 }) }}
                                    ><Icons.BackArrowIcon2 /></div>

                                    {
                                        Object.keys(expandedTable || {})?.sort()?.map(key =>
                                            <>
                                                {key != 0 && <div className='text-xs font-semibold'>/</div>}
                                                <GenericCustomButton
                                                    className='!ml-0 text-xs font-semibold px-[1px] w-fit text-fontBlack hover:text-primary'
                                                    label={`${expandedTable?.[key]?.value}`}
                                                    onClick={() => handleChange("mouseLeave", expandedTable?.[key], { level: key })}
                                                />
                                            </>
                                        )
                                    }
                                </div>
                            } */}

                            {checkItems?.length != 0 && listData?.filter(item => item?.value?.toLowerCase()?.includes(searchContent?.[level]?.toLowerCase() || ""))?.map((item, index) => {
                                item = modifyItemForPrinterBarcode(item);
                                let isExpandAvailable = item?.["explore"]?.data ? true : false;
                                
                                

                                return (
                                    <div key={item?.key} style={{ position: 'relative' }}
                                        onClick={() => (isExpandAvailable && expandedTable?.[level]?.key != item?.key && handleChange("mouseOver", item, { level: level }))}
                                    >
                                        <button className={`!ml-0 px-3 py-2 flex justify-between w-full bg-white text-sm font-medium text-gray-700 hover:!bg-[#F5F5F5]`}>
                                            <div className='flex items-center gap-2.5 cursor-pointer'>
                                                {item?.["url"] ? <img className='w-[16px] h-[16px] object-contain' src={item?.["url"]} /> : <Icons.DefaultReportIcon />}
                                                <TextWithTooltip width={160} as="label" className='whitespace-nowrap font-medium text-[#0F172A] mr-[15px] truncate max-w-[160px]' text={item?.value || ""} />
                                            </div>
                                            <div className='flex gap-2 items-center'>
                                                {
                                                    !isExpandAvailable && (
                                                        <GenericCustomButton
                                                            type='outline'
                                                            size='small'
                                                            leftIcon={<span><Icons.DownloadIcon /></span>}
                                                            onClick={() => {
                                                                downloadFunction({
                                                                    item: item,
                                                                    type: "FALSE",
                                                                })
                                                            }}
                                                            disabled={downloadDocumentsData?.isLoading || props.downloadDocuments?.disableItems?.({
                                                                selectedItems: checkItems,
                                                                currentItem: item,
                                                            })}
                                                        />
                                                    )
                                                }

                                                {/* {item?.["type"] != "printerBarcode" && */}
                                                {!isPreviewButtonHidden(item?.key) && <GenericCustomButton
                                                    type='outline'
                                                    size='small'
                                                    // className='border rounded-full border-black hover:bg-black hover:text-white'
                                                    leftIcon={(item?.["type"] != "printerBarcode" && isExpandAvailable) ? <span><Icons.RightArrowExpand /></span> : <span><Icons.PasswordEyeIconSmall /></span>}
                                                    disabled={(isExpandAvailable ? props.downloadDocuments?.disableItems?.({
                                                        selectedItems: checkItems,
                                                        currentItem: item,
                                                    }) : downloadDocumentsData?.isLoading) || props.downloadDocuments?.disableItems?.({
                                                        selectedItems: checkItems,
                                                        currentItem: item,
                                                    })}
                                                    onClick={isExpandAvailable ? () => handleChange("mouseOver", item, { level: level }) : (e) => {
                                                        e.stopPropagation()
                                                        downloadFunction({
                                                            item: item,
                                                            type: "TRUE",
                                                        })
                                                    }}
                                                />}
                                                {/* } */}
                                            </div>
                                        </button>

                                    </div>
                                )
                            })
                            }

                            {listData?.filter(item => item?.value?.toLowerCase()?.includes(searchContent?.[level]?.toLowerCase() || "")).length === 0 && (
                                <div className='text-custom-14 text-center py-3'>No Results Found</div>
                            )}

                        </div>
                    </div> : renderDownloadDocumentList(expandedTable?.[level]?.["explore"]?.["data"], level + 1)}
                </motion.div>
                </AnimatePresence>
            </div>

        )
    }

    const getParentChildProps = () => {
        switch(selectedModal){
            case "printDocument" : {
                return{
                    closeModal: () => { setSelectedModal(null) },
                    animationType: "bottom",
                    parentModalOuterMostClassName: 'flex items-center justify-center',
			        postitionProps: { position: 'relative' },
                    dimensions: window.location.hash?.includes("/mdm/manage/set") ?
                        {width: "55%", height: '75%', maxHeight: "1000px", maxWidth: '1400px', borderRadius:'0'}
                        :
                        {width: "450px", height: 'fit-content', maxHeight: "80vh", overflowY:'auto', borderRadius:'0'},
                    mainType : window.location.hash?.includes("/mdm/manage/set") ? "downloadAndPrint" : "normal",
                    downloadBarcodeConfig : selectedData,
                }
            }
            case "documentsQtyForPrint" : {
                return {
                    closeModal: () => { setSelectedModal(null) },
                    animationType: "bottom",
                    parentModalOuterMostClassName: 'flex items-center justify-center',
			        postitionProps: { position: 'relative' },
                    dimensions: window.location.hash?.includes("/mdm/manage/set") ?
                        {width: "55%", height: '75%', maxHeight: "1000px", maxWidth: '1400px', borderRadius:'0'}
                        :
                        {width: "450px", height: 'fit-content', maxHeight: "80vh", overflowY:'auto', borderRadius: 5},
                    selectedData : selectedData,
                    checkItems : checkItems,
                    downloadFunction : downloadFunction,
                }
            }
            default : 
        }
    }

    const getChildComponent = () => {
        switch(selectedModal){
            case "printDocument" : return PrintDocument
            case "documentsQtyForPrint" : return DocumentsQtyForPrint;
            default :
        }
    }


    return (
        <React.Fragment>

            <div className='download-document-dropdown h-[300px] overflow-hidden'>
                {renderDownloadDocumentList(downloadDocumentsConfigurationObject?.["type"], 0)}
            </div>

            {/* {renderDownloadDocumentList(downloadDocumentsConfigurationObject?.["type"], 0)} */}


            {selectedModal ? <ParentModal
                getParentChildProps={getParentChildProps()}
                childComponent={getChildComponent()}
                closeModal={() => { setSelectedModal(false) }}
            /> : null}
        </React.Fragment>
    )
}

export default DocumentsDropdown